import { ENGINEERING_SYSTEMS_CDN_PATH } from '../../../engineering-systems-constants';
import { HeaderSectionStructure } from '../../../components/header-section/header-section-types';

export const HEATING_HEADER_SECTION_CONFIG: HeaderSectionStructure = {
  title: 'Системы отопления',
  description:
    'Спроектируем и\u00A0установим систему отопления любой сложности под ключ. Выполняем работы от\u00A0сварки труб и\u00A0установки радиатора до\u00A0обвязки и\u00A0настройки котельного оборудования. Оформите заявку, а\u00A0мы\u00A0подберём решение, составим проект и\u00A0установим оборудование у\u00A0вас дома.',
  img: {
    src: `${ENGINEERING_SYSTEMS_CDN_PATH}/systems/2_2.jpg/2_2.jpg`,
    alt: 'Системы отопления',
  },
  consultationSignupBtn: {
    elementBlock: 'landingSistemyOtopleniya',
    label: 'Записаться на консультацию',
    elementText: 'Системы отопления',
  },
};
